import * as angular from 'angular';
import {IController, IOnChangesObject} from "angular";
import {PackingInfoStatusType} from "../../types/packing-info-status.type";
import * as _ from "lodash";

export class DeliveryPackedIndicationCtrl implements IController {
  isPacked: any;
  packingInfo: any;
  packedDate: any;
  packageList: any;
  totalItems: any;
  serviceType: any;

  public hasMissingPackages: boolean;
  public packingDisplayStatus: PackingInfoStatusType;
  public packingInfoStatusTypes: typeof PackingInfoStatusType = PackingInfoStatusType;
  public packagesCount: number = 0;


  constructor() {
  }

  $onInit() {
    this._setHasMissingPackages();
    this._setDisplayStatus();
    this.setPackagesCount();
  }

  $onChanges(changes: IOnChangesObject) {
    if (changes.packageList && !changes.packageList.isFirstChange() ||
      changes.isPacked && !changes.isPacked.isFirstChange() ||
      changes.packingInfo && !changes.packingInfo.isFirstChange()) {
      this._setHasMissingPackages();
      this._setDisplayStatus();
      this.setPackagesCount();
    }
  }

  private setPackagesCount() {
    this.packagesCount = _.reduce(this.packageList, (totalItems, p: any) => {
      return totalItems + p.count;
    }, 0) || 0;
  }

  private _setHasMissingPackages() {
    const packageListRef = this.packageList ? this.packageList[0] : {items: []};
    this.hasMissingPackages = packageListRef.items.find(item => {
      return item.missing;
    })
  }

  private _setDisplayStatus() {
    this.packingDisplayStatus = this.packingInfo?.status ||
      (this.isPacked ? this.packingInfoStatusTypes.Packed : this.packingInfoStatusTypes.NotPacked);
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('deliveryPackedIndication', {
    bindings: {
      isPacked: '<',
      packedDate: '<?',
      packingInfo: '<?',
      packageList: '<?',
      totalItems: '<?',
      serviceType: '<?'
    },
    template: require('./delivery-packed-indication.html').default,
    controller: DeliveryPackedIndicationCtrl
  });
